import { SignInPage } from "@backstage/core-components";
import { configApiRef, useApi, type SignInPageProps } from "@backstage/core-plugin-api";
import { dexAuthApiRef } from "../../apis";
import DexRedirectSignInPage from "./DexRedirectSignInPage";

export function EnvironmentSignInPage(props: SignInPageProps) {
  const configApi = useApi(configApiRef);
  const env = configApi.getOptionalString("auth.environment") ?? "development";

  if (env === "production") {
    return (
      <DexRedirectSignInPage
        {...props}
        provider={{
          id: "oidc",
          title: "Dex",
          message: "Sign in with Dex",
          apiRef: dexAuthApiRef,
        }}
      />
    );
  }

  return <SignInPage {...props} providers={["guest"]} />;
}
